import { Button, Modal } from "react-bootstrap";
import { LoadingSpinner } from "../../../components/common/Loading/LoadingSpinner";

export type UnsavedChangesModalProps = {
    show: boolean;
    saving?: boolean;
    title?: string;
    message?: string;
    cancelLabel?: string;
    saveAndContinueLabel?: string;
    continueWithoutSavingLabel?: string;
    onCancel: () => void;
    /** When provided, shows Save and continue (3-button mode). Omit for 2-button mode. */
    onSaveAndContinue?: () => void;
    onContinueWithoutSaving: () => void;
};

const DEFAULT_TITLE = "Unsaved changes";
const DEFAULT_MESSAGE = "You have unsaved changes. Do you want to save them before you continue?";
const DEFAULT_CANCEL = "Cancel";
const DEFAULT_SAVE_AND_CONTINUE = "Save and continue";
const DEFAULT_CONTINUE_WITHOUT_SAVING = "Continue without saving";

export function UnsavedChangesModal({
    show,
    saving = false,
    title = DEFAULT_TITLE,
    message = DEFAULT_MESSAGE,
    cancelLabel = DEFAULT_CANCEL,
    saveAndContinueLabel = DEFAULT_SAVE_AND_CONTINUE,
    continueWithoutSavingLabel = DEFAULT_CONTINUE_WITHOUT_SAVING,
    onCancel,
    onSaveAndContinue,
    onContinueWithoutSaving,
}: UnsavedChangesModalProps) {
    const threeButtonMode = onSaveAndContinue !== undefined;

    return (
        <Modal show={show} onHide={onCancel} centered keyboard={!saving}>
            <Modal.Header closeButton={!saving}>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{message}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" disabled={saving} onClick={onCancel}>
                    {cancelLabel}
                </Button>
                {threeButtonMode && (
                    <Button variant="primary" disabled={saving} onClick={onSaveAndContinue}>
                        {saving ? <LoadingSpinner text="Saving…" /> : saveAndContinueLabel}
                    </Button>
                )}
                <Button
                    variant={threeButtonMode ? "outline-primary" : "primary"}
                    disabled={saving}
                    onClick={onContinueWithoutSaving}
                >
                    {continueWithoutSavingLabel}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

/** True when the modal renders Save and continue (3-button mode). */
export function isUnsavedChangesThreeButtonMode(onSaveAndContinue?: () => void): boolean {
    return onSaveAndContinue !== undefined;
}
